import { Map } from 'immutable';

import {
  PLAN_INTERVAL,
  PRODUCT_API_TESTING,
  PRODUCT_LIVE,
  PRODUCT_MOBILE_QUALITY,
  PRODUCT_RDC,
  PRODUCT_USAGE,
  PRODUCT_VDC,
  CONCURRENCY_KEY,
  INTERVAL_KEY,
  PROJECTS_KEY,
  CREDIT_BLOCKS_KEY,
} from '../../constants';
import {
  INITIALIZED,
  INITIALIZE_WITH_PLANS,
  REMOVE_CROSS_BROWSER_CONFIG,
  SET_WEB_AND_MOBILE_TESTING_TAB,
  UPDATE_PRODUCT_CONFIG,
} from './types';
import { PlanConfiguration } from '../../records/PlanConfiguration';

const initialState = Map({
  account: null,
  billingInfo: null,
  configuration: Map({
    [PRODUCT_LIVE]: new PlanConfiguration({ [CONCURRENCY_KEY]: 0 }),
    [PRODUCT_RDC]: new PlanConfiguration({ [CONCURRENCY_KEY]: 0 }),
    [PRODUCT_VDC]: new PlanConfiguration({ [CONCURRENCY_KEY]: 0 }),
    [PRODUCT_MOBILE_QUALITY]: new PlanConfiguration({ [CONCURRENCY_KEY]: 0 }),
    [PRODUCT_API_TESTING]: new PlanConfiguration({ [PROJECTS_KEY]: 0 }),
    [PRODUCT_USAGE]: new PlanConfiguration({
      [CREDIT_BLOCKS_KEY]: 0,
      interval: PLAN_INTERVAL.MONTH,
    }),
  }),
  couponCode: null,
  currentWebAndMobileTab: null,
  initialized: false,
});

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case INITIALIZED:
      return state.set('initialized', true);
    case SET_WEB_AND_MOBILE_TESTING_TAB:
      return state.set('currentWebAndMobileTab', payload);
    case INITIALIZE_WITH_PLANS: {
      const newConfiguration = state.get('configuration')
        .withMutations((mutable) => {
          Object.keys(payload).forEach((key) => (
            mutable.set(key, new PlanConfiguration(payload[key]))
          ));
        });

      return state.set('configuration', newConfiguration);
    }
    case UPDATE_PRODUCT_CONFIG: {
      const {
        [CREDIT_BLOCKS_KEY]: creditBlocks,
        concurrency,
        interval,
        projects,
        product,
      } = payload;

      const newConfiguration = state.get('configuration').withMutations((mutable) => {
        const draft = { ...mutable.get(product) };

        if (Number.isFinite(concurrency)) {
          draft[CONCURRENCY_KEY] = concurrency;
        }
        if (Number.isFinite(projects)) {
          draft[PROJECTS_KEY] = projects;
        }
        if (Number.isFinite(creditBlocks)) {
          draft[CREDIT_BLOCKS_KEY] = creditBlocks;
        }

        if (interval) {
          draft[INTERVAL_KEY] = interval;
        }

        mutable.set(product, new PlanConfiguration(draft));
      });

      return state.set('configuration', newConfiguration);
    }
    case REMOVE_CROSS_BROWSER_CONFIG: {
      return state.withMutations((mutable) => {
        mutable.setIn(['configuration', PRODUCT_LIVE], initialState.getIn(['configuration', PRODUCT_LIVE]));
        mutable.setIn(['configuration', PRODUCT_VDC], initialState.getIn(['configuration', PRODUCT_VDC]));
        mutable.setIn(['configuration', PRODUCT_RDC], initialState.getIn(['configuration', PRODUCT_RDC]));
        mutable.setIn(['configuration', PRODUCT_API_TESTING], initialState.getIn(['configuration', PRODUCT_API_TESTING]));
        mutable.setIn(['configuration', PRODUCT_MOBILE_QUALITY], initialState.getIn(['configuration', PRODUCT_MOBILE_QUALITY]));
        mutable.setIn(['configuration', PRODUCT_USAGE], initialState.getIn(['configuration', PRODUCT_USAGE]));
        mutable.set('currentWebAndMobileTab', null);
      });
    }
    default:
      return state;
  }
};
